// extracted by mini-css-extract-plugin
export default {"container":"AboutTitleAndContent_container__ls-5N"};